import { authRegisterError, authRegisterSuccess } from '@store/slices/auth/authSlice.js';
import httpClient from '@utils/httpClient';
import { call, put } from 'redux-saga/effects';
// import { loginRequestSaga } from './login';

function registerApiCall({ name, email, password }) {
  return httpClient.post(`api/account/register`, {
    name,
    email,
    password,
    confirmPassword: password,
    code: 'next',
  });
}

export function* registerRequestSaga({ payload: { name, email, password } }) {
  try {
    yield call(registerApiCall, { name, email, password });
    yield put(authRegisterSuccess());
    // yield call(loginRequestSaga, { email, password });
  } catch (error) {
    console.log('error', error);

    const errorData = error?.response?.data;
    let errorTaken = '';

    if (errorData?.modelState) {
      const isError = errorData?.modelState.hasOwnProperty('');

      if (isError) {
        errorTaken = errorData?.modelState[''];

        const isArray = Array.isArray(errorTaken);
        if (isArray) {
          errorTaken = errorTaken[errorTaken?.length - 1];
        }
      }
    }

    console.log(errorTaken ? errorTaken : errorData?.message ? errorData?.message : error?.message ? error?.message : error?.toString());

    yield put(authRegisterError(errorTaken ? errorTaken : errorData?.message ? errorData?.message : error?.message ? error?.message : error?.toString()));
    // yield put(authRegisterError(Date.now()));
  }
}
